import { createContext } from 'react';

export const ItinerarySelectionActionsContext = createContext();
